import API from "../Services/API";
import Model from "./Model";
import State from "./State";

const usePredefined = (alwaysRefresh) => {
    return Model({
        alwaysRefresh,
        stateKey: ['services', 'predefined'],
        fetchData: () => API.get('/services/predefined'),
        returnDataKey: 'predefined',
        defaultLoadingError: 'Failed to load services.',
    });
}


const useServices = (alwaysRefresh) => {
    return Model({
        alwaysRefresh,
        stateKey: ['services'],
        fetchData: () => API.get('/services'),
        returnDataKey: 'services',
        subscribeToUpdates: {
            topic: 'services',
            handler: (data, opts) => {
                opts.refresh();
            },
        },
        saveAdditionalData: (response) => {
            response.map((service) => {
                State.putIfNotExists(['service', service.id], service);
                return service;
            });
        },
        registerAdditionalMethods: (opts) => {
            return {
                addService: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/services', data),
                        null,
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Failed to load services.',
    });
}

const useService = (serviceId, alwaysRefresh) => {
    return Model({
        alwaysRefresh,
        stateKey: ['service', serviceId],
        fetchData: () => API.get('/services/'+serviceId),
        returnDataKey: 'service',
        subscribeToUpdates: {
            entity: {entityModel: 'Services/Service', entityId: serviceId},
            handler: (data, opts) => {
                opts.refresh();
            },
        },
        defaultLoadingError: 'Failed to load service.',
        registerAdditionalMethods: (opts) => {
            return {
                update: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/services/'+serviceId, data),
                        null,
                        true,
                    );
                },
                deleteService: () => {
                    return opts.wrapUpdateCall(
                        () => API.delete('/services/'+serviceId),
                        null,
                        true,
                    );
                }
            }
        },
    });
}


const defaults = [
    {
        type: 'bin',
        title: 'Bin cleaning',
    },
    {
        type: 'carpet',
        title: 'Carpet Cleaning',
    },
    {
        type: 'commercial',
        title: 'Commercial Window Cleaning',
    },
    {
        type: 'conservatory',
        title: 'Conservatory Cleaning',
    },
    // {
    //     type: 'driveway',
    //     title: 'Driveway Cleaning',
    // },
    {
        type: 'exterior',
        title: 'Exterior (Cladding/Render/Soffit)',
    },
    {
        type: 'greenhouse',
        title: 'Greenhouse Cleaning',
    },
    {
        type: 'gutter',
        title: 'Gutter Clearing',
    },
    {
        type: 'inside',
        title: 'Inside Window Cleaning',
    },
    {
        type: 'other',
        title: 'Other',
    },
    // {
    //     type: 'outside',
    //     title: 'Outside Window Cleaning',
    // },
    {
        type: 'oven',
        title: 'Oven cleaning',
    },
    {
        type: 'pressure',
        title: 'Pressure Washing',
    },
    // {
    //     type: 'reach',
    //     title: 'Reach Window Cleaning',
    // },
    {
        type: 'quote',
        title: 'Quote',
    },
    {
        type: 'residential',
        title: 'Residential Window Cleaning',
    },
    {
        type: 'roof',
        title: 'Roof cleaning',
    },
    // {
    //     type: 'sash',
    //     title: 'Sash Window Cleaning',
    // },
    // {
    //     type: 'soffit',
    //     title: 'Soffit & Fascia Cleaning',
    // },
    {
        type: 'solar',
        title: 'Solar Panel Cleaning',
    },
    {
        type: 'valet',
        title: 'Car valet',
    },
];


export {
    usePredefined,
    useServices,
    useService,
    defaults,
};
